import Vue from 'vue'
import Vuex from 'vuex'
import taxModule from './modules/tax-module';
import salesModule from "@/store/modules/Sale/sales-module";
import emailModule from "@/store/modules/Sale/email-module"
import stockModule from "@/store/modules/Stock/stockmodule";
import stockCategories from "@/store/modules/Stock/stockcategory-module";
import floatModule from "@/store/modules/Sale/float-module";
import tableModule from "@/store/modules/Sale/table-module";
import cookingInstruction from "@/store/modules/Sale/cookingInstruction";
import stockTake from '@/store/modules/Stock/stock-take-module';
import paymentMethods from '@/store/modules/Sale/payment-methods-module.js';
import accounts from "@/store/modules/Accounts/accounts";
import kazangModule from "@/store/modules/Sale/kazang_module";
import supplierModule from "@/store/modules/supplier-module.js";
import stockReceivedModule from "@/store/modules/Stock/stock-received-module";
import stockTransferModule from "@/store/modules/Stock/stock-transfer-module";
import kazangPayment from "@/store/modules/Kazang/payment";
import kazangSignUp from "@/store/modules/Kazang/sign-up-module";
import customInstall from "@/store/modules/Sale/custom-install-module";
import billingModule from "@/store/modules/billing-module";
import backOfficeModule from "@/store/modules/backoffice-module";
import ticketModule from './modules/ticket-module'
import timeModule from './modules/time-module';
import axios from "axios";
import {Storage} from "@/services/Storage"
import {responses} from "@/utils/responses";
import userModule from "@/store/modules/user_module";
import kitchenOrdersModule from "@/store/modules/Sale/kitchen-orders-module.js";
import router from "@/router";
import { setUsageUser, setUsageStore, trackEvent, flushEvents } from "@/services/UsageTracker";
import queryStringify from "qs-stringify";
import Swal from "sweetalert2";
import ticket_notes_module from "@/store/modules/ticket_notes_module";
import {idbTransactionalStorage, restoreState, saveState} from '@/services/idbStorage';


import VuexPersistence from 'vuex-persist'


Vue.use(Vuex)
const vuexLocal = new VuexPersistence({
    storage: idbTransactionalStorage,
    asyncStorage: true,
    key: "vuex",
    restoreState,
    saveState
});
let CurrentTime = function () {
    let date = new Date();
    let d = date.toISOString().split('T')[0]
    let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
    let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let t = hour + ':' + minute + 'hrs';
    return d + ` at ` + t;
}
const store = new Vuex.Store({
    state: {
        zra_details: null,
        defaultStore: null,
        device_settings: null,
        baseCurrency: {Symbol: `K`},
        lastUpdated: '',
        loading: false,
        isHydrated: false,
        registrationDetails: null,
        isUpdateAvailable: false,
        isSmartInvoicing: false,

    },
    getters: {
        isHydrated: (state) => state.isHydrated,
        getSmartInvoicingStatus: (state) => state.isSmartInvoicing,
        getZRADetails: (state) => state.zra_details,
        getRegistrationDetails: (state) => state.registrationDetails,
        getRegisteredStores: (state) => state.allStores,
        getLoadingState: (state) => state.loading,
        getDefaultStore: (state) => state.defaultStore,
        getDeviceSettings: (state) => state.device_settings,
        getLasUpdated: (state) => state.lastUpdated,
        getBaseCurrency: (state) => state.baseCurrency,
        getUpdateAvailability: (state) => state.isUpdateAvailable,
        currentDate: () => {
            let date = new Date();
            return date.toISOString().split('T')[0];
        },

        currentTime: () => {
            let date = new Date();
            let d = date.toISOString().split('T')[0]
            let hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
            let minute = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
            let t = hour + ':' + minute;
            return d + `T` + t;
        },
    },
    mutations: {
        setSmartInvoicingStatus: (state, payload) => state.isSmartInvoicing = payload,
        setMobileUser: (state, payload) => {
            state.admin = payload;
        },
        toggleNavigation: (state, width) => state.navigation = width,
        setLoadingState: (state, payload) => state.loading = payload,
        setRegisteredStores: (state, payload) => {
            state.allStores = payload
            localStorage.setItem("all_stores", payload);
        },
        setZraDetails: async (state, data) => {
            state.zra_details = data;
        },
        setAllStores: async (state, payload) => {
            state.allStores = payload;
        },
        setLastUpdated: (state, payload) => state.lastUpdated = payload,
        setUpdateAvailability: (state, payload) => state.isUpdateAvailable = payload,
        setDeviceSettings: async (state, payload) => {
            state.device_settings = payload
        },

        setBaseCurrency: async (state, payload) => {
            state.baseCurrency = payload
        },

        setRegistrationDetails: (state, payload) => {
            state.registrationDetails = payload
        },


        setDefaultStore: (state, data) => {
            state.defaultStore = data;
            try {
                Imeis.saveStoreDB(data?data.StoreDB:null);
                if (window.developmentMode) responses.showInfo(`Saved Kazang ID : ${data?data.StoreDB:null}`)
            } catch (e) {
                responses.throwErr(e)
                // responses.showWarning(`Please update your Kazang POS application`)
            }

        },
    },
    actions: {
        signOutOfStore: async (context) => {
            let user = await Storage.getCurrentUser();
            if (!!user && isValidString(user.Username)) {
                context.dispatch('recordLogout', user.Username);
            }
            await Promise.all([
                context.commit(`setCurrentUser`, {
                    Type: "",
                    Username: "",
                    id: "",
                    Surname: "",
                    Name: "",
                    Password: ""
                }),
                context.commit(`setDefaultStore`, null),
                context.commit(`setRegistrationDetails`, null),
                context.commit(`setDeviceSettings`, null),
                context.commit(`setStock`, []),
                context.commit(`setStockSetting`, []),
                context.commit(`setAllStores`, []),
                context.commit(`setAllUsers`, []),
                context.commit(`setAllSecurities`, []),
                context.commit(`setDiscountSpecials`, []),
                context.commit(`setAllSecurities`, []),
                context.commit(`setComboSpecials`, []),
                context.commit(`setMultiSpecials`, []),
                context.commit(`setBaseCurrency`, {Symbol: `K`}),
                context.commit('setCurrentSale', 0),
                context.commit('setCurrentLines', []),
                context.commit('setDebtors', []),
                context.commit('setCustomer', ''),
            ])
            console.log(`Store Info Cleared`);
        },
        posLogout: async (context, payload) => {
            let loggedIn = context.getters.getCurrentUser
            let user = loggedIn.Username;
            if (user === 'Admin') {
                user = localStorage.getItem('supportAgent');
                localStorage.removeItem('supportAgent');
            }
            const auth = {
                Type: "",
                Username: "",
                id: "",
                Surname: "",
                Name: "",
                Password: ""
            }
            await Storage.setCurrentUser(auth)
            let getCurrentUser = await Storage.getCurrentUser();
            await context.commit(`setCurrentUser`, auth)
            await context.dispatch('recordLogout', user)
            trackEvent('auth', 'logout', { userId: user });
            flushEvents();
            console.log(loggedIn)
            console.log(getCurrentUser)
            return router.push({name: 'poslogin'})
        },
        syncData: async ({dispatch, commit}) => {
            await Storage.getDefaultStore()
            return axios.all([
                dispatch("getCustomerDetails"),
                dispatch("updateToLatestVersion"),
                dispatch('getAllStock'),
                dispatch('getAllUsers'),
                dispatch('getBaseCurrency'),
                dispatch('getDeviceSettings'),
                dispatch("getCategories"),
                dispatch("isKazangIntegrated"),
                dispatch("getAllPaymentMethods"),
                dispatch("getAllStores"),
                dispatch("getAllActiveSpecials"),
                dispatch("getAllFranchiseSettings"),
                dispatch("getAllSecurities"),
            ]).then(() => {
                commit("setKazangSession");
                commit('setLastUpdated', CurrentTime())
            });

        },
        appLogin: (context, payload) => {
            return axios.post(franchiseTomcatApi + 'AndroidLogin/Attempt', payload)
                .then(async ({data}) => {
                    if (data.StoreDB && data.StoreName) {
                        await Storage.setAdminUser(payload);
                        return context.dispatch(`loginToStore`, data)
                    }
                    await Storage.setAdminUser(payload);
                    return router.push({name: 'setup'});

                }).catch((err) => errorHandler.tomcatError(err)).finally(() => $utils.hideLoading())
        },

        getCustomerDetails: async (context) => {
            let store = await Storage.getDefaultStore();
            if (!store) {
                // During initial boot/migration, defaultStore may not be ready yet.
                // Avoid redirecting here; let the router guard and App.vue flow handle it.
                return;
            }
            return axios.get(franchiseTomcatApi + `stores/getRegistrationDetails`, {
                params: {database: store.StoreDB}
            }).then(async ({data}) => {
                Storage.setRegistrationDetails(data)
                return context.dispatch("getExpiryDateByCustomerID");
            }).catch((err) => errorHandler.tomcatError(err))
        },
        checkSmartInvoicing: async (context) => {
            let storeDB = await Storage.getCurrentStoreDB();
            if (!storeDB) return;
            let user = await Storage.getCurrentUser();
            return axios.get(franchiseTomcatApi + `GRV/${storeDB}/checkSmartInvoicing`)
                .then(({data}) => {
                    context.commit(`setSmartInvoicingStatus`, data)
                    let isLive = context.getters.getSmartInvoicingLive;
                    if (!data && isLive) {
                        return context.dispatch(`checkIfStoreDocsSubmitted`).then(() => {
                            let hasDocs = context.getters.getDocSubmissionStatus;
                            if (!hasDocs && (!!user && isValidString(user.Username))) {
                                return Swal.fire({
                                    title: 'Register for Smart Invoicing Now',
                                    text: 'You are not registered for smart invoicing. Please register now.',
                                    icon: 'warning',
                                    showCancelButton: true,
                                    showCloseButton: true,
                                    allowOutsideClick: false,
                                    confirmButtonText: 'Register',
                                    cancelButtonText: 'Cancel'
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        return router.push({name: 'smart-invoicing-setup'});
                                    }
                                });
                            }
                        })
                    }
                }).catch((err) => errorHandler.tomcatError(err))
        },

        confirmationText: (context, payload) => {
            return Swal.fire({
                title: 'Authorization',
                icon: 'info',
                html:
                    '<div style="font-family: Arial, sans-serif;' +
                    '        font-size: 16px;' +
                    '        line-height: 1.5;' +
                    '        color: #333;' +
                    '        background-color: #f7f7f7;' +
                    '        padding: 20px;' +
                    '        border: 1px solid #ccc;' +
                    '        border-radius: 5px;' +
                    '        margin: 20px 0;">' +
                    '<p><strong>Please note:</strong> By clicking on the "Confirm" button, you are authorizing the ' +
                    'automatic monthly deduction of K100.00 from your Kazang account as part of the subscription model ' +
                    'for this software.</p></div>',
                showCloseButton: false,
                showCancelButton: true,
                confirmButtonText: `Confirm`,
                focusConfirm: false,
            }).then((res) => {
                if (res.isConfirmed) {
                    return context.dispatch(`setupStore`, payload)
                }
            })
        },

        setupStore: async (context, payload) => {
            return Swal.fire({
                title: 'Please Enter your Business TPIN',
                icon: 'question',
                input: 'number',
                showCancelButton: true,
                confirmButtonText: 'Confirm',
                showLoaderOnConfirm: true,
                allowOutsideClick: false,
                preConfirm: async (inputValue) => {
                    if (inputValue.length !== 10) return Swal.showValidationMessage(`TPIN must be 10 characters`);
                    if (inputValue === `1018444641`) return Swal.showValidationMessage(`Please enter your Business TPIN`);
                    payload.DeviceID = await Device.getDeviceId();
                    payload.data = await Storage.getAdminUser();
                    payload.tpin = inputValue;
                    return axios.post(franchiseTomcatApi + `AndroidLogin/SecondeReg`, payload)
                        .then(({data}) => context.dispatch(`loginToStore`, data))
                        .catch((err) => errorHandler.tomcatError(err))
                },
            });
        },

        loginToStore: async (context, payload) => {
            await context.commit(`setDefaultStore`, payload);
            // Set store context for usage tracking
            setUsageStore(payload.StoreDB);
            await context.dispatch("updateToLatestVersion");
            // syncData is non-blocking here: a failure (e.g. transient IMEI/setting
            // lookup on web) must not abort the Lyt-ning guard below. defaultStore.StoreDB
            // is already committed above and is what checkProductAccess needs for Stage 1.
            try {
                await context.dispatch(`syncData`);
            } catch (e) {
                console.warn('[loginToStore] syncData failed, continuing with Lyt-ning check', e);
            }

            // Block login if the selected store is on the Lytning product (productId === 3).
            // Runs BEFORE the userCount early-return so a Lyt-ning store is denied even
            // when syncData failed (no users loaded). Inverse of the Lytning app's
            // blocking logic: LytSoft POS must allow only non-Lytning products.
            try {
                await context.dispatch('checkProductAccess');
            } catch (e) {
                try { errorHandler.tomcatError(e, false, 'Login Blocked'); } catch (_) {}
                try {
                    await context.dispatch('signOutOfStore');
                } catch (_) {}
                try {
                    const curr = router.currentRoute;
                    if (!curr || curr.name !== 'login') {
                        router.replace({ name: 'login' }).catch(() => {});
                    }
                } catch (_) {}
                return;
            }

            let userCount = await context.getters.countNonLytSoftUsers;
            if (userCount === 0 || !userCount) {
                return router.push({name: 'create-initial-user'})
            }
            // Validate device registration right after admin/store login; do not block navigation on failure
            try {
                await context.dispatch('validateDeviceRegistration');
            } catch (e) {
                // Non-blocking: surface via global handler but continue
                try { errorHandler.tomcatError(e, false, 'Device Validation'); } catch (_) {}
            }
            // After successful admin login + store selection, respect redirect query once
            const redirect = (router.currentRoute && router.currentRoute.query) ? router.currentRoute.query.redirect : null;
            if (redirect) {
                const target = decodeURIComponent(String(redirect));
                if (router.currentRoute.fullPath !== target) {
                    return router.replace(target).catch(() => {});
                }
            }
            return router.push({name: 'poslogin'})
        },
        getDeviceSettings: async (context) => {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            let device = await Device.getDeviceId();
            return axios.get(serverApi + `settings/${store.StoreDB}/${device}`)
                .then(({data}) => context.commit('setDeviceSettings', data))
                .catch((err) => errorHandler.tomcatError(err, false, 'Error on Settings'))
        },

        getFloatUsers: async (context) => {
            let store = await Storage.getDefaultStore();
            return axios.get(franchiseTomcatApi + `cashup/${store.StoreDB}/noneFloat`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        assignFloat: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(`${serverApi}float/assign/${store.StoreDB}`, payload)
                .then(({data}) => {
                    if (!data.assigned) {
                        responses.throwErr(data.message)
                        return false;
                    }
                    context.commit('setUserFloat', {
                        user: payload.user,
                        device: payload.device,
                        supervisor: data.supervisor,
                        float: Number(payload.amount)
                    });
                    return true;
                }).catch((err) => errorHandler.tomcatError(err))
        },
        checkFloat: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(`${serverApi}float/check/${store.StoreDB}`, payload)
                .catch((err) => errorHandler.tomcatError(err))
        },
        getcashUpDiff: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(`${serverApi}cashup/${store.StoreDB}/status`, payload)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        saveSettings: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            return axios.post(`${serverApi}settings/${store.StoreDB}`, payload).then(({data}) => {
                context.commit('setDeviceSettings', data)
                return context.dispatch(`syncData`);
            }).catch((err) => errorHandler.tomcatError(err))
        },
        getStockLocations: async () => {
            let store = await Storage.getDefaultStore();
            return axios.get(`${serverApi}locations/${store.StoreDB}`)
                .then(({data}) => data)
                .catch((err) => errorHandler.tomcatError(err))
        },
        cashUpUser: async (context, payload) => {
            let isAllowed = await context.dispatch(`validateSecurityPermission`, `CompleteCashup`);
            if (!isAllowed) throw new Error(`User not allowed to Cashup`);
            let store = await Storage.getDefaultStore()
            let device = await Storage.getDeviceSettings();
            payload.PC = device.PC
            return axios.post(`${serverApi}cashup/${store.StoreDB}`, payload)
                .then(async ({data}) => {
                    let float = await Storage.getFloat()
                    float = float ? float.filter(f => f.user !== payload.user) : [];
                    let methods = [
                        axios.post(franchiseTomcatApi + `emailrecord/${store.StoreDB}/emailCashup`, {
                            cashup: data.response.cashupNum
                        }),
                        Storage.setFloat(float)
                    ];
                    try {
                        methods.push(Printing.printCashup(JSON.stringify(data)))
                    } catch (e) {
                    }


                    if (store.Group === '1004117420') {
                        axios.get(franchiseTomcatApi + `navision/${store.StoreDB}/cashupPrintDsrCashup/cashup/${data.response.cashupNum}`)
                            .then((res) => {
                                let jsonData = res.data;
                                try {
                                    Printing.printDsrCashup(JSON.stringify(jsonData))
                                } catch (e) {
                                }
                            }).catch(err => errorHandler.tomcatError(err));
                    }

                    return axios.all(methods).finally(() => responses.showInfo('Cash up completed successfully'));
                }).catch((err) => errorHandler.tomcatError(err))
        },

        printCashup: async (context, cashupNumber) => {
            let store = await Storage.getDefaultStore();
            return axios.get(serverApi + `cashup/${store.StoreDB}/${cashupNumber}`)
                .then(({data}) => {
                    try {
                        Printing.printCashup(JSON.stringify(data))
                    } catch (e) {
                    }
                }).catch((err) => errorHandler.tomcatError(err))
        },

        getBaseCurrency: async (context) => {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            return axios.get(franchiseTomcatApi + `currency/${store.StoreDB}/getBaseCurrency`)
                .then(({data}) => context.commit('setBaseCurrency', data))
                .catch((err) => errorHandler.tomcatError(err))
        },
        upgradeKazangPOSCustomer: async (context, payload) => {
            let obj = queryStringify(payload);
            return axios.put(franchiseTomcatApi + `stores/upgradeKazangPOSCustomer?` + obj)
                .then(() => context.dispatch(`getCustomerDetails`))
                .catch((err) => errorHandler.tomcatError(err))
        },

        checkExpiry: async () => {
            let store = await Storage.getDefaultStore();
            if (!store) {
                return;
            }
            let storeDB = store.StoreDB;
            return axios.get(backOfficeApiGET, {
                params: {
                    route: `other/getExpiryDate?Database=` + storeDB,
                }
            }).then(({data}) => {
                let expireDate = new Date(data);
                let today = new Date();
                return expireDate < today;
            });
        },

        updateToLatestVersion: async () => {
            let store = await Storage.getDefaultStore();
            if (!store) return;
            return axios.put(franchiseTomcatApi + `version/${store.StoreDB}/updateToLatest`);
        },

        /**
         * Validate the current device registration against Subscription Manager
         * - Uses registrationDetails.mainCustomerID
         * - Uses Device.getDeviceId() for the device identifier
         * - Sends platform=KanzangPos and isMobile=false as required
         * This action is non-blocking for the login flow; errors are handled silently via errorHandler.
         * @returns {Promise<void>}
         */
        validateDeviceRegistration: async (context) => {
            try {
                // Ensure we have registration details; fall back to Storage if state is not yet populated
                let registration = context.getters.getRegistrationDetails;
                if (!registration) {
                    registration = await Storage.getRegistrationDetails();
                }
                if (!registration || !registration.mainCustomerID) {
                    return; // Nothing to validate yet
                }
                const deviceID = await Device.getDeviceId();
                const params = {
                    customerID: registration.id,
                    platform: 'KazangPOS',
                    deviceID: deviceID,
                    isMobile: false,
                };
                await axios.get(subscriptionApi + 'devices/validatePCRegistration', { params });
            } catch (err) {
                // If validation does not return HTTP 200, force logout and send the user to the admin login screen
                try { errorHandler.tomcatError(err, false, 'Device Validation'); } catch (_) {}
                try {
                    await context.dispatch('signOutOfStore');
                } catch (_) {}
                try {
                    // Use router navigation (no hardcoded URL) per project guidelines
                    // Only navigate if not already on the login route
                    const curr = router.currentRoute;
                    if (!curr || curr.name !== 'login') {
                        router.replace({ name: 'login' }).catch(() => {});
                    }
                } catch (_) {}
            }
        },
        /**
         * Block login if the selected store's subscription is on the Lytning product (productId === 3).
         * Inverse of the Lytning app's logic: LytSoft POS must allow only non-Lytning products
         * (Lyt-Soft, VCD, etc.). Per-store check matches the Lytning app's per-store behavior:
         * sibling LytSoft stores under the same customer can still log in.
         *
         * Two-stage check (added 2026-06-26 after store 9090856559 / Bola Bet failed the old check):
         *   1. HelpDesk `/stores/GetStoreProductId?storeId=<customerID>` — reads product_id
         *      directly from burntofi_latestreg.customer by `Database` column. Authoritative
         *      when reachable, because it doesn't depend on the device's cached mainCustomerID.
         *   2. Fallback to SubscriptionManager `getStoresByCustomer?mainCustomerID=...`,
         *      matching by `s.id`, `Number(s.id)`, or `s.database` (the kazang DB name).
         *      The old code only matched by `s.id` and missed stores where the device's
         *      CustomerID is the kazang DB name (e.g. "9090856559") rather than the
         *      burntofi_latestreg.customer.id (e.g. 434 for the same store).
         *
         * Fails open on API errors so a transient backend outage does not lock cashiers
         * out of the POS — the block is a guardrail, not a hard dependency.
         *
         * @throws {Error} when any check confirms productId === 3 (caller handles signout + redirect).
         */
        checkProductAccess: async (context) => {
            // The selected store was committed to state.defaultStore at the start of loginToStore.
            // The payload comes from AndroidLogin/Attempt — its identifying field is `StoreDB`
            // (the kazang store DB name, e.g. "9090856559"). Fall back to CustomerID/id for
            // other dispatch paths (syncData, setDefaultStore(null)) that may pass a richer object.
            const store = context.state.defaultStore;
            const customerID = store && (store.StoreDB ?? store.CustomerID ?? store.id);
            if (customerID === undefined || customerID === null || customerID === '') return;

            // --- Stage 1: HelpDesk direct product lookup. Authoritative when reachable. ---
            try {
                const helpdeskRes = await axios.get(
                    kazangHelpDeskApi + `stores/GetStoreProductId`,
                    { params: { storeId: String(customerID) } }
                );
                const productId = Number(helpdeskRes && helpdeskRes.data && helpdeskRes.data.productId);
                if (productId === 3) {
                    throw new Error(
                        `Store "${helpdeskRes.data.storeName || customerID}" is on the Lytning product ` +
                        `(productId=3) and cannot log in to Kazang POS. Contact support to migrate.`
                    );
                }
                // productId 1 (Lyt-Soft) or 2 (Kazang POS) — allow login.
                return;
            } catch (blockErr) {
                // Re-throw if this was our own Lytning block — don't catch our own throw.
                if (blockErr && /Lytning product/.test(blockErr.message)) throw blockErr;
                // HelpDesk unreachable or returned 404 for this storeId — fall through to stage 2.
                console.warn('[checkProductAccess] HelpDesk lookup unavailable, falling back to SubscriptionManager', blockErr);
            }

            // --- Stage 2: SubscriptionManager fallback (per-MainCustomerID). ---
            let registration = context.getters.getRegistrationDetails;
            if (!registration) {
                try { registration = await Storage.getRegistrationDetails(); } catch (_) {}
            }
            if (!registration || !registration.mainCustomerID) return;

            let response;
            try {
                response = await axios.get(
                    subscriptionApi + `customer/getStoresByCustomer`,
                    { params: { mainCustomerID: registration.mainCustomerID } }
                );
            } catch (err) {
                // Fail open — do not lock cashiers out on a transient subscription API issue.
                console.warn('[checkProductAccess] subscription API unreachable, allowing login', err);
                return;
            }

            const stores = Array.isArray(response && response.data) ? response.data : [];
            // Three match strategies — the device may carry any of these as CustomerID:
            //   a) s.id === customerID           (SubscriptionManager internal PK = burntofi customer.id)
            //   b) Number(s.id) === Number(customerID)  (handles "434" vs 434)
            //   c) s.database === customerID     (kazang store DB name, e.g. "9090856559")
            const storeInfo = stores.find(s => s && (
                String(s.id) === String(customerID) ||
                Number(s.id) === Number(customerID) ||
                String(s.database) === String(customerID)
            ));
            if (!storeInfo) {
                // Selected store not present in subscription list — likely a misconfigured customer.
                // Fail open and log so this can be investigated if it recurs.
                console.warn(`[checkProductAccess] store id ${customerID} not in getStoresByCustomer response; allowing login`);
                return;
            }

            if (Number(storeInfo.productId) === 3) {
                // Lytning product — block login on this device.
                throw new Error(
                    `Store "${storeInfo.storeName || customerID}" is on the Lytning product ` +
                    `(productId=3) and cannot log in to Kazang POS. Contact support to migrate.`
                );
            }
        },

    },
    modules: {
        salesModule,
        stockModule,
        stockCategories,
        userModule,
        floatModule,
        tableModule,
        emailModule,
        kazangPayment,
        cookingInstruction,
        stockTake,
        paymentMethods,
        accounts,
        kazangModule,
        supplierModule,
        stockReceivedModule,
        stockTransferModule,
        kazangSignUp,
        customInstall,
        billingModule,
        backOfficeModule,
        kitchenOrdersModule,
        ticketModule,
        timeModule,
        taxModule,
        ticket_notes_module
    },
    plugins: [
        vuexLocal.plugin,
    ],
})
export default store;

